import { InlineEditPropsStrict } from '@servicetitan/design-system';

export enum UrgentFollowUpTabs {
  Open = 'Open',
  Cold = 'Cold',
  Done = 'Done',
}

export type InlineEditControlProps = Parameters<
  Exclude<InlineEditPropsStrict['control'], undefined>
>[0];

export type DismissModalError = {
  title: string;
  retry?: () => void;
  retryLabel?: string;
};
